import {CLEAR_ERRORS, GET_ERRORS} from "./types";

export const clearErrors = () => {
    return {
        type: CLEAR_ERRORS
    };
};

export const getErrors = (err) => {
    return {
        type: GET_ERRORS,
        payload: err.response.data
    };
};



// WEBPACK FOOTER //
// ./src/features/Errors/actions.js